import React, { useState, useEffect, useRef } from 'react';
import './PriceUpdate.scss';

const PriceUpdate = ({ 
  oldRate, 
  newRate,
  oldAmount, 
  newAmount,
  isMobileView,
  isRateAndAmountCase,
  triggerAnimation = false,
  isRTL = false
}) => {
  const [showOffer, setShowOffer] = useState(false);
  const containerRef = useRef(null);

  // Only start observing after triggerAnimation is true.
  // Animation fires when element scrolls into view after user confirms.
  useEffect(() => {
    if (!triggerAnimation) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShowOffer(true);
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );
    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, [triggerAnimation]);

  return (
    <div className={`price-widget-wrapper ${isRateAndAmountCase ? 'rate-and-amount-case' : ''} ${isMobileView ? 'mobile-view' : ''} ${isRTL ? 'rtl' : ''}`} ref={containerRef}>
      <div className={`price-container ${showOffer ? 'updated' : ''}`}>
        
        {/* --- Old Price Container --- */}
        <div className="old-price">
          <span className="strike-line"></span>
          
          {oldRate && <span className="rate-text">{oldRate}</span>}
          {oldRate && oldAmount && <span className="separator-hyphen">&nbsp;-&nbsp;</span>}
          <span className="amount-text">{oldAmount}</span>
        </div>

        {/* --- New Price Container --- */}
        <div className="new-price">
          
          {newRate && <span className="rate-text">{newRate}</span>}
          {newRate && newAmount && <span className="separator-hyphen">&nbsp;-&nbsp;</span>}
          <span className="amount-text">{newAmount}</span>
        </div>

      </div>
    </div>
  );
};

export default PriceUpdate;